import { branchService } from '@/_service/branch.service'
import { IOption, IReservationValues } from '@/_types'
import React, { Dispatch, SetStateAction, useCallback, useState } from 'react'
import { CField } from '@/_components/CField'
import AsyncSelect from './async-select'
import { customStyles } from './async-select'
import { useTranslations } from 'next-intl'
import BranchesMap from './map'
import { useActiveBrand } from '@/_hooks/useActiveBrand'
import { Box } from '@chakra-ui/react'
import { useQueryState } from 'nuqs'

const OPEN_MAP_OPTION: IOption = {
    label: 'Показать на карте филиалы',
    value: 'open_map',
}

function MenuListWithStickyFirst({ children, innerProps, ...props }: any) {
    const childArray = React.Children.toArray(children)
    const [first, ...rest] = childArray
    return (
        <Box {...innerProps}>
            <Box maxHeight='300px' overflowY='auto'>
                {rest}
            </Box>
            {first && (
                <div
                    style={{
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'var(--bg-card)',
                        zIndex: 1,
                        paddingTop: '8px',
                    }}
                >
                    {first}
                </div>
            )}
        </Box>
    )
}

interface IProps {
    formData: IReservationValues
    setFormData: Dispatch<SetStateAction<IReservationValues>>
    isEditable: boolean
}

export default function BranchSelect({ formData, setFormData, isEditable }: IProps) {
    const [open, setOpen] = useState(false)

    const [queryBranchId] = useQueryState('branch_id')
    const shipperId = useActiveBrand()
    const t = useTranslations()

    const loadBranches = useCallback(
        (inputValue: string, callback: (options: IOption[]) => void) => {
            branchService
                .getList({ search: inputValue, page: 1, limit: 50 }, shipperId)
                .then((res) => {
                    const branchesList = res?.data?.branches?.map((branch) => {
                        const matchesQuery =
                            queryBranchId &&
                            (queryBranchId === branch?.id ||
                                queryBranchId === branch?.slug)
                        if (matchesQuery && !formData?.branch_id?.value) {
                            setFormData((prev) => ({
                                ...prev, branch_id: {
                                    label: branch?.name,
                                    value: branch?.id,
                                }
                            }))
                        }
                        return ({
                            label: branch?.name,
                            value: branch?.id,
                        })
                    }) ?? []
                    if (queryBranchId) {

                    }
                    callback([OPEN_MAP_OPTION, ...branchesList])
                })
                .catch((error) => console.log(error))
        },
        [shipperId, queryBranchId]
    )

    return (
        <>
            <CField label={t('select_branch')} bgColor='background'>
                <AsyncSelect
                    isClearable
                    isSearchable
                    defaultOptions
                    value={formData?.branch_id}
                    loadOptions={loadBranches}
                    styles={customStyles({
                        color: 'text',
                    })}
                    components={{ MenuList: MenuListWithStickyFirst }}
                    onChange={(val: IOption) => {
                        if (val?.value === 'open_map') {
                            setOpen(true)
                        } else {
                            setFormData((prev) => ({ ...prev, branch_id: val }))
                        }
                    }}
                    isDisabled={!isEditable}
                />
            </CField>
            <BranchesMap
                open={open}
                onClose={() => { setOpen(false) }}
                onChange={(branch) => {
                    setFormData((prev) => ({ ...prev, branch_id: { value: branch?.id, label: branch?.name } }))
                }}
            />
        </>
    )
}
